import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { customersGridViews } from '../../../components/customers-grid/views';
import GridTitle from '../../../components/grid-header/grid-header-title';
import style from '../../../components/grid-header/grid-header.module.less';
import ListWithOverflow from '../../../components/list-with-overflow';
import { useQuickSearchTerm } from '../../../hooks/routing/use-quick-search-term';
import Global from '../../../store/global-selectors';
import { CustomerGridButtons } from '../grid-available-buttons';

const getView = (baseViews, id) => {
  return baseViews.find((c) => c.id === id);
};

export const CustomersGridHeaderContainer = ({ children }) => {
  const quickSearchTerm = useQuickSearchTerm();
  const currentView = useSelector(Global.selectCustomersViewView);

  const view = useMemo(() => {
    const { id } = currentView;
    const baseView = getView(customersGridViews, id);

    const buttons = CustomerGridButtons.map((button, i) => (
      <button.type key={i} id={button.id} overflowName={button.overflowName}>
        {button.menu ? <button.menu /> : null}
      </button.type>
    ));

    const requiredRenderIndices = CustomerGridButtons.map((button, index) => (button.requiredRender ? index : -1)).filter(
      (index) => index !== -1,
    );

    const label = baseView && baseView.label;
    const hideSearchPrefix = baseView && baseView.hideSearchPrefix;

    return {
      id,
      hideSearchPrefix,
      buttons,
      requiredRenderIndices,
      label,
    };
  }, [currentView]);

  const hasButtons = view && Array.isArray(view.buttons) && view.buttons.length > 0;

  return (
    <div className={style['grid-header-wrapper']}>
      <div className={style['grid-header-container']}>
        <div className={style['view-details-container']}>
          <div className={style['view-name']}>
            <GridTitle searchTerm={quickSearchTerm} view={view} />
          </div>
        </div>
        {children ? <div className={style['right-aligned-buttons-container']}>{children}</div> : null}
      </div>
      {hasButtons ? (
        <div className={style['actions-container']}>
          <ListWithOverflow
            componentOverflowDisplayPropName='overflowName'
            componentsToRender={view.buttons}
            customOverflowDropdown={null}
            ignoreCustomOverflow
            overflowToggleInVisibleContainer={false}
            requiredRenderIndices={view.requiredRenderIndices}
          />
        </div>
      ) : null}
    </div>
  );
};
